<template>
    <div id="content">
        <!--
        <Menu page="index"></Menu>
        -->

        <transition appear name="appear">
            <div class="lds-spinner" v-if="!store.projects.length">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </transition>
        <div v-if="store.projects.length" id="table">
            <div v-if="$mq == 'desktop'" id="tableHead">
                <div id="titleCont">
                    <div id="title" class="left" @click="handleSort('title')">
                        Title
                        <span
                            v-if="
                                store.sorting == 'title' &&
                                    store.sortingOrder == 1
                            "
                            >&#x2193;</span
                        >
                        <span
                            v-else-if="
                                store.sorting == 'title' &&
                                    store.sortingOrder == -1
                            "
                            >&#x2191;</span
                        >
                    </div>
                    <div
                        id="year"
                        class="right"
                        @click="handleSort('year_order')"
                    >
                        <span
                            v-if="
                                store.sorting == 'year_order' &&
                                    store.sortingOrder == 1
                            "
                            >&#x2193;</span
                        >
                        <span
                            v-else-if="
                                store.sorting == 'year_order' &&
                                    store.sortingOrder == -1
                            "
                            >&#x2191;</span
                        >
                        Year
                    </div>
                </div>
                <div id="clientCont">
                    <div id="type" class="left" @click="handleSort('type')">
                        Type
                        <span
                            v-if="
                                store.sorting == 'type' &&
                                    store.sortingOrder == 1
                            "
                            >&#x2193;</span
                        >
                        <span
                            v-else-if="
                                store.sorting == 'type' &&
                                    store.sortingOrder == -1
                            "
                            >&#x2191;</span
                        >
                    </div>
                    <div id="client" class="left" @click="handleSort('client')">
                        Client
                        <span
                            v-if="
                                store.sorting == 'client' &&
                                    store.sortingOrder == 1
                            "
                            >&#x2193;</span
                        >
                        <span
                            v-else-if="
                                store.sorting == 'client' &&
                                    store.sortingOrder == -1
                            "
                            >&#x2191;</span
                        >
                    </div>
                    <div
                        id="images"
                        class="right"
                        @click="handleSort('images')"
                    >
                        <span
                            v-if="
                                store.sorting == 'images' &&
                                    store.sortingOrder == 1
                            "
                            >&#x2193;</span
                        >
                        <span
                            v-else-if="
                                store.sorting == 'images' &&
                                    store.sortingOrder == -1
                            "
                            >&#x2191;</span
                        >
                        Slides
                    </div>
                </div>
            </div>
            <div v-else id="tableHead" class="mobile">
                <div
                    id="title"
                    class="left select"
                    @click="handleSort('title')"
                    :class="{ active: store.sorting == 'title' }"
                >
                    Title
                </div>
                <!-- <div -->
                <!--     id="type" -->
                <!--     class="right select" -->
                <!--     @click="handleSort('type')" -->
                <!--     :class="{ active: store.sorting == 'type' }" -->
                <!-- > -->
                <!--     Type -->
                <!-- </div> -->
                <!-- <div -->
                <!--     id="type" -->
                <!--     class="right select" -->
                <!--     @click="handleSort('client')" -->
                <!--     :class="{ active: store.sorting == 'client' }" -->
                <!-- > -->
                <!--     Client -->
                <!-- </div> -->
                <div
                    id="year"
                    class="right select"
                    @click="handleSort('year_order')"
                    :class="{ active: store.sorting == 'year_order' }"
                >
                    Year
                </div>
            </div>
            <NewIndexItem
                v-for="project in store.projects"
                :key="project.id"
                :project="project"
            ></NewIndexItem>
        </div>
    </div>
</template>

<script>
import { store } from "@/centralStore";
import IndexItem from "@/components/IndexItem";
import NewIndexItem from "@/components/NewIndexItem";
import Menu from "@/components/Menu";
export default {
    name: "NewIndex",
    components: {
        IndexItem,
        NewIndexItem,
        Menu
    },
    data() {
        return {
            store: store.state
            //sorting: 'year',
            //sortingOrder: 1,
        };
    },
    methods: {
        handleSort(sorting) {
            var myself = this;
            if (sorting == myself.store.sorting) {
                myself.store.sortingOrder = myself.store.sortingOrder * -1;
            } else {
                myself.store.sorting = sorting;
                myself.store.sortingOrder = 1;
            }
            //myself.store.projects = myself.store.projects.sort((a,b) => {
            //if (b['end_year'] == null){
            //return 1;

            //} else if (a['end_year'] < b['end_year']){
            //return 1;
            //}
            //if (a['year'] > b['year']){
            //return 1 * myself.store.sortingOrder;
            //}
            //})
            myself.store.projects = myself.store.projects.sort((a, b) => {
                if (myself.store.sorting == "type") {
                    if (a.category.name < b.category.name) {
                        return -1 * myself.store.sortingOrder;
                    }
                    if (a.category.name > b.category.name) {
                        return 1 * myself.store.sortingOrder;
                    }
                } else if (myself.store.sorting == "images") {
                    if (
                        a.images.filter(i => i.is_paired_with_next == false)
                            .length <
                        b.images.filter(i => i.is_paired_with_next == false)
                            .length
                    ) {
                        return -1 * myself.store.sortingOrder;
                    }
                    if (
                        a.images.filter(i => i.is_paired_with_next == false)
                            .length >
                        b.images.filter(i => i.is_paired_with_next == false)
                            .length
                    ) {
                        return 1 * myself.store.sortingOrder;
                    }
                } else if (myself.store.sorting == "title") {
                    if (a.title.toLowerCase() < b.title.toLowerCase()) {
                        return -1 * myself.store.sortingOrder;
                    }
                    if (a.title.toLowerCase() > b.title.toLowerCase()) {
                        return 1 * myself.store.sortingOrder;
                    }
                } else {
                    if (a[myself.store.sorting] < b[myself.store.sorting]) {
                        return -1 * myself.store.sortingOrder;
                    }
                    if (a[myself.store.sorting] > b[myself.store.sorting]) {
                        return 1 * myself.store.sortingOrder;
                    }
                }
                return 0;
            });
            var counter = 1;
            var images = [];
            var allImages = [];
            var pairMark = false;
            myself.store.projects.forEach(project => {
                project.images.forEach(img => {
                    img.counter = counter;
                    allImages.push(img);
                    if (!pairMark) {
                        images.push(img);
                        counter += 1;
                    } else {
                        pairMark = false;
                    }
                    if (img.is_paired_with_next) {
                        pairMark = true;
                    }
                });
            });
            // myself.store.orderedImages = images;
            console.log(
                "sort swiper",
                images.map(i => i.project)
            );
            myself.store.orderedImages = images;
        }
    },
    computed: {
        // sortedProjects() {
        //     var myself = this;
        //     myself.store.projects = myself.store.projects.sort((a, b) => {
        //         if (myself.store.sorting == "type") {
        //             if (a.category.name < b.category.name) {
        //                 return -1 * myself.store.sortingOrder;
        //             }
        //             if (a.category.name > b.category.name) {
        //                 return 1 * myself.store.sortingOrder;
        //             }
        //         } else {
        //             if (a[myself.store.sorting] < b[myself.store.sorting]) {
        //                 return -1 * myself.store.sortingOrder;
        //             }
        //             if (a[myself.store.sorting] > b[myself.store.sorting]) {
        //                 return 1 * myself.store.sortingOrder;
        //             }
        //         }
        //         return 0;
        //     });
        //
        //     return 1;
        // }
    },
    activated() {
        let myself = this;
        //this.store.inverted = false;
        this.store.indexTransition = "";
        //setTimeout(function(){
        //myself.store.currentImage = null;
        //}, 1000)
        //this.store.detailTransition = 'slideDown'
    },
    mounted() {
        this.store.inverted = false;
        this.store.lastIndex = "index-dev";
    }
};
</script>

<style scoped>
#content {
    /*position: absolute;*/
    top: 0;
    width: 100%;
    height: 100%;
    height: -webkit-fill-available;
    /*overflow: auto;*/
    background-color: black;
}
table {
    width: calc(100vw - 2rem);
    table-layout: fixed;
    border-collapse: collapse;
    /*margin-top: 6px;
    margin-right: 16px;
    margin-left: 16px;*/
    margin: 1rem 1rem 0 1rem;
}
#table {
    margin: 0rem 1rem 0.5rem 1rem;
    width: calc(100vw - 2rem);
    position: relative;
    display: flex;
    flex-direction: column;
}
@media screen and (min-width: 768px) {
    #table {
        margin: 0rem 1rem 0.5rem 1rem;
    }
}
thead {
    /*position: sticky;*/
    top: 0;
}
th {
    font-weight: normal;
    padding: 0.5rem 0 0.5rem;
    color: #969696;
    cursor: pointer;
}
tr {
    border-top: 1px solid black;
    border-bottom: 1px solid black;
}
@media screen and (min-width: 768px) {
    th:hover {
        color: #232323;
    }
}
th.left {
    text-align: left;
}
th.right {
    text-align: right;
}
.select.active {
    color: white;
}
th > span {
    margin: 0 5px;
}
#titleCont,
#clientCont {
    flex-basis: 50%;
    display: flex;
}
#title {
    /*width: 33.3%;*/
    flex: 3;
    margin-right: 1rem;
}
#year {
    /*width: 16.6%;*/
    text-align: right;
    margin-right: 0.5rem;
}
#type {
    /*width: 16.6%;*/
    margin-left: 0.5rem;
    /*flex-basis: 188px;*/
    flex-basis: 33%;
}
#client {
    /*width: 16.6%;*/
    flex: 3;
}
#images {
    /*width: 16.6%;*/
    text-align: right;
}
#titleCont span,
#clientCont span {
    margin: 0 0.25rem 0 0.2rem;
}
#tableHead {
    display: flex;
    padding-top: 0.3rem;
    padding-bottom: 0.55rem;
    border-bottom: 1px solid #565656;
    /*border-top: 1px solid black;*/
    /*position: sticky;*/
    top: -1px;
    color: #969696;
    /*background-color: white;*/
}
.mobile > #title {
    width: auto;
    flex: 1;
}
.mobile > #type {
    text-align: right;
    width: auto;
    flex-basis: auto;
    margin-left: 1rem;
}
.mobile > #year {
    text-align: right;
    width: auto;
    margin-left: 1rem;
    margin-right: 0;
    /*flex-basis: 3.7rem;*/
    flex-basis: auto;
}
#tableHead > div {
    cursor: pointer;
    white-space: nowrap;
}
@media screen and (min-width: 768px) {
    #tableHead > div:hover {
        color: white;
    }
}
@media screen and (min-width: 768px) {
    #tableHead > div {
        cursor: default;
    }
    #tableHead > div > div {
        cursor: pointer;
    }
    #tableHead > div:hover {
        color: #969696;
    }
    #tableHead > div > div:hover {
        color: white;
    }
}
/*
.slideUp-enter-active,
.slideUp-leave-active{
    transition: 1s;
}

.slideUp-enter{
    transform: translateY(100%);
}
.slideUp-leave-to{
    transform: translateY(100%);
}
*/

.slideDown-leave-active,
.slideDown-enter-active {
    transition: 0.7s;
}

.slideDown-enter {
    transform: translateY(100vh);
}
.slideDown-enter-to {
}
.slideDown-leave {
}
.slideDown-leave-to {
    transform: translateY(100vh);
}

.lds-spinner {
    color: official;
    display: inline-block;
    position: absolute;
    width: 80px;
    height: 80px;
    left: calc(50% - 40px);
    top: calc(50% - 40px);
    transform: scale(0.5);
}
.lds-spinner div {
    transform-origin: 40px 40px;
    animation: lds-spinner 1.2s linear infinite;
}
.lds-spinner div:after {
    content: " ";
    display: block;
    position: absolute;
    top: 3px;
    left: 37px;
    width: 6px;
    height: 18px;
    border-radius: 20%;
    background: #fff;
}
.lds-spinner div:nth-child(1) {
    transform: rotate(0deg);
    animation-delay: -1.1s;
}
.lds-spinner div:nth-child(2) {
    transform: rotate(30deg);
    animation-delay: -1s;
}
.lds-spinner div:nth-child(3) {
    transform: rotate(60deg);
    animation-delay: -0.9s;
}
.lds-spinner div:nth-child(4) {
    transform: rotate(90deg);
    animation-delay: -0.8s;
}
.lds-spinner div:nth-child(5) {
    transform: rotate(120deg);
    animation-delay: -0.7s;
}
.lds-spinner div:nth-child(6) {
    transform: rotate(150deg);
    animation-delay: -0.6s;
}
.lds-spinner div:nth-child(7) {
    transform: rotate(180deg);
    animation-delay: -0.5s;
}
.lds-spinner div:nth-child(8) {
    transform: rotate(210deg);
    animation-delay: -0.4s;
}
.lds-spinner div:nth-child(9) {
    transform: rotate(240deg);
    animation-delay: -0.3s;
}
.lds-spinner div:nth-child(10) {
    transform: rotate(270deg);
    animation-delay: -0.2s;
}
.lds-spinner div:nth-child(11) {
    transform: rotate(300deg);
    animation-delay: -0.1s;
}
.lds-spinner div:nth-child(12) {
    transform: rotate(330deg);
    animation-delay: 0s;
}
@keyframes lds-spinner {
    0% {
        opacity: 1;
    }
    100% {
        opacity: 0;
    }
}
.appear-enter-active,
.appear-leave-active {
    transition: opacity 0.5s;
}
.appear-enter, .appear-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}
</style>
